import { toast, ToastOptions, ToastPosition } from 'react-toastify';

type ToastType = 'success' | 'error' | 'warning' | 'info';

export const useToast = () => {
  const showToast = (
    message: string,
    type: ToastType = 'info',
    options: ToastOptions = {},
  ) => {
    const defaultOptions: ToastOptions = {
      position: 'top-right' as ToastPosition,
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };

    const toastOptions = { ...defaultOptions, ...options };

    switch (type) {
      case 'success':
        toast.success(message, toastOptions);
        break;
      case 'error':
        toast.error(message, toastOptions);
        break;
      case 'warning':
        toast.warn(message, toastOptions);
        break;
      default:
        toast.info(message, toastOptions);
    }
  };

  return { showToast };
};
